import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Logo from "@/components/Logo";

export default function Footer() {
  return (
    <footer
      className="relative border-t border-white/5 px-5 sm:px-8 py-20 md:py-28"
      data-testid="footer"
    >
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 1.0, ease: [0.16, 1, 0.3, 1] }}
          className="grid grid-cols-2 md:grid-cols-12 gap-10 md:gap-12 mb-16"
        >
          <div className="col-span-2 md:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <Logo size={32} />
              <p className="font-sans font-semibold text-xl text-foreground tracking-[-0.025em]">
                Nisky Auto
              </p>
            </div>
            <p
              className="leading-relaxed max-w-md text-[15px]"
              style={{ letterSpacing: "-0.01em", color: "#b8b8c0" }}
            >
              Mobile car detailing for Niskayuna, NY. Showroom finish, delivered.
              Operating each summer, June 18 to September 6.
            </p>
          </div>
          <div className="md:col-span-3">
            <p className="overline mb-5">Navigate</p>
            <ul className="space-y-3 text-[15px]">
              <li>
                <Link
                  to="/"
                  className="text-foreground/75 hover:text-gold transition-colors"
                  data-testid="footer-home"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/book"
                  className="text-foreground/75 hover:text-gold transition-colors"
                  data-testid="footer-book"
                >
                  Book a detail
                </Link>
              </li>
              <li>
                <Link
                  to="/status"
                  className="text-foreground/75 hover:text-gold transition-colors"
                  data-testid="footer-status"
                >
                  Booking status
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-foreground/75 hover:text-gold transition-colors"
                  data-testid="footer-contact"
                >
                  Contact us
                </Link>
              </li>
            </ul>
          </div>
          <div className="md:col-span-4">
            <p className="overline mb-5">Service window</p>
            <ul className="space-y-3 text-[15px] text-foreground/75">
              <li>Niskayuna, NY · mobile only</li>
              <li>9 AM – 10 PM, daily</li>
              <li>June 18 – September 6</li>
            </ul>
          </div>
        </motion.div>

        <div
          className="pt-8 border-t border-white/5 flex flex-col md:flex-row justify-between gap-4 text-xs text-faint"
          style={{ letterSpacing: "0.02em" }}
        >
          <span>© {new Date().getFullYear()} Nisky Auto · Niskayuna NY</span>
          <span className="flex gap-6 flex-wrap">
            <Link to="/privacy" className="hover:text-gold transition-colors">
              Privacy Policy
            </Link>
            <Link to="/terms" className="hover:text-gold transition-colors">
              Terms of Service
            </Link>
            <span>Cinematic detailing, by appointment.</span>
          </span>
        </div>
      </div>
    </footer>
  );
}
